export function checkCapability(
  capabilityName: string | string[],
  capabilitiesArray: { name: string }[]
) {
  if (typeof capabilityName === 'string') {
    capabilityName = [capabilityName];
  }
  return capabilityName.some((name) =>
    capabilitiesArray?.some((capability) => capability.name === name)
  );
}

type Tuple3 = [number, number, number];

interface LightingConfig {
  startColor: Tuple3;
  peakColor: Tuple3;
  valleyColor: Tuple3;
  amp1: number;
  wave1: number;
  speed1: number;
  amp2: number;
  wave2: number;
  speed2: number;
  amp3: number;
  wave3: number;
  speed3: number;
}

interface LightingCommand {
  CH: number[];
  FUNCTION: string;
  Config: LightingConfig;
}

function parseWrappedJson<T = any>(s: string): T {
  const open = s.indexOf('(');
  const close = s.lastIndexOf(')');
  if (open === -1 || close === -1 || close <= open) {
    throw new Error('Formato inválido (no se encontró (...))');
  }
  const json = s.slice(open + 1, close);
  return JSON.parse(json) as T;
}

export function parseLightingArray<T = LightingCommand>(arr: string[]): T[] {
  return arr.map(parseWrappedJson<T>);
}
